/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimEmailAttachment
 */
export interface ClaimEmailAttachment {
    /**
     * 
     * @type {number}
     * @memberof ClaimEmailAttachment
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimEmailAttachment
     */
    claimEmailId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimEmailAttachment
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimEmailAttachment
     */
    mimeType: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimEmailAttachment
     */
    sizeBytes: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimEmailAttachment
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ClaimEmailAttachment interface.
 */
export function instanceOfClaimEmailAttachment(value: object): value is ClaimEmailAttachment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimEmailId' in value) || value['claimEmailId'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ClaimEmailAttachmentFromJSON(json: any): ClaimEmailAttachment {
    return ClaimEmailAttachmentFromJSONTyped(json, false);
}

export function ClaimEmailAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimEmailAttachment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimEmailId': json['claimEmailId'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ClaimEmailAttachmentToJSON(json: any): ClaimEmailAttachment {
    return ClaimEmailAttachmentToJSONTyped(json, false);
}

export function ClaimEmailAttachmentToJSONTyped(value?: Omit<ClaimEmailAttachment, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimEmailId': value['claimEmailId'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

